import { AsyncPipe, CommonModule, NgForOf, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
    FormBuilder,
    FormControl,
    FormGroup,
    FormsModule,
    ReactiveFormsModule,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-chat-controls',
    templateUrl: './chat-controls.component.html',
    styleUrls: ['./chat-controls.component.scss'],
    imports: [
        CommonModule,
        MatButtonModule,
        MatChipsModule,
        MatCardModule,
        MatFormFieldModule,
        MatIconModule,
        MatProgressBarModule,
        NgIf,
        ReactiveFormsModule,
        NgForOf,
        MatInputModule,
        FormsModule,
        AsyncPipe,
    ],
    standalone: true,
})
export class ChatControlsComponent implements OnInit {
    @Output() sendMessage: EventEmitter<string> = new EventEmitter();
    @Input() aiBuffering$: Observable<boolean>;
    protected messageControl: FormControl;
    protected chatForm: FormGroup;
    constructor(private fb: FormBuilder) {}
    // TODO Implement attachment support

    ngOnInit(): void {
        this.scrollBottom();
        this.messageControl = new FormControl();
        this.chatForm = this.fb.group({ message: this.messageControl });
        this.aiBuffering$.subscribe((bufferingStatus: boolean) => {
            if (bufferingStatus) {
                this.messageControl.disable();
            } else {
                this.messageControl.enable();
            }
        });
    }

    protected submit(): void {
        const msg: string = this.messageControl.value;
        if (msg.length < 1) {
            return;
        }

        this.sendMessage.emit(this.messageControl.value);
        this.messageControl.reset();
        this.scrollBottom();
    }

    private scrollBottom(): void {
        setTimeout(() => window.scrollTo(0, document.body.scrollHeight), 500);
    }

    protected setSelectedFiles(event): void {
        //Basic Framework for implementing file attachments
    }

    protected deleteAttachment(file): void {
        //Basic Framework for implementing file attachments
    }

    protected getAttachments(): File[] {
        //Basic Framework for implementing file attachments
        return '' as unknown as File[];
    }

    protected hasAttachments() {
        //Basic Framework for implementing file attachments
    }
}
